import { SiteType } from '~/utilities/graphql/codegen';

// Google Play package ids for the native apps that replace the Highstreet app from
// 2026-06-30. gstar / outlet / employeeshop share the same G-Star RAW app (the Play
// listing carries over to the new supplier under the existing package id).
const GSTAR_PLAY_PACKAGE_ID = 'com.highstreet.gstar';
const AAF_PLAY_PACKAGE_ID = 'com.appliedartforms';

// Maps keyed by SiteType (rather than a ternary) so adding an app later is a single
// entry, and a new SiteType forces an explicit choice here at compile time.
const ANDROID_PLAY_PACKAGE_IDS: Record<SiteType, string | null> = {
  [SiteType.Gstar]: GSTAR_PLAY_PACKAGE_ID,
  [SiteType.Outlet]: GSTAR_PLAY_PACKAGE_ID,
  [SiteType.Employeeshop]: GSTAR_PLAY_PACKAGE_ID,
  [SiteType.Aaf]: AAF_PLAY_PACKAGE_ID,
  [SiteType.Wahts]: null,
};

const ANDROID_APP_NAMES: Record<SiteType, string> = {
  [SiteType.Gstar]: 'G-Star RAW',
  [SiteType.Outlet]: 'G-Star RAW',
  [SiteType.Employeeshop]: 'G-Star RAW',
  [SiteType.Aaf]: 'Applied Art Forms',
  [SiteType.Wahts]: 'Wahts',
};

export const getAndroidPlayPackageId = (siteType: SiteType): string | null =>
  ANDROID_PLAY_PACKAGE_IDS[siteType];

export const getAndroidAppName = (siteType: SiteType): string => ANDROID_APP_NAMES[siteType];

export const buildPlayStoreUrl = (packageId: string): string =>
  `https://play.google.com/store/apps/details?id=${packageId}`;

export const ANDROID_USER_AGENT_PATTERN = /android/i;

export const isAndroidUserAgent = (userAgent = ''): boolean =>
  ANDROID_USER_AGENT_PATTERN.test(userAgent);
